const legsFilters = [
    {
        filterDisplayName: "Style",
        subFilters: [
            {
                filterDisplayName: "Plain",
                filterType: "collection",
                filterHandle: "regular-legs",
            },
            {
                filterDisplayName: "Short Legs",
                filterType: "collection",
                filterHandle: "short-legs",
            },
            {
                filterDisplayName: "Shorts & Skirts",
                filterType: "collection",
                filterHandle: "legs-trousers-and-skirts",
            },
            {
                filterDisplayName: "Trackies & Jeans",
                filterType: "collection",
                filterHandle: "trackies-jeans",
            },
        ],
    },
    {
        filterDisplayName: "Colour",
        subFilters: [
            {
                filterDisplayName: "Black",
                filterType: "metafield",
                filterNamespace: "custom",
                filterHandle: "black",
                filterKey: "colour",
            },
            {
                filterDisplayName: "Blue",
                filterType: "metafield",
                filterNamespace: "custom",
                filterHandle: "blue",
                filterKey: "colour",
            },
            {
                filterDisplayName: "Grey",
                filterType: "metafield",
                filterNamespace: "custom",
                filterHandle: "grey",
                filterKey: "colour",
            },
            {
                filterDisplayName: "White",
                filterType: "metafield",
                filterNamespace: "custom",
                filterHandle: "white",
                filterKey: "colour",
            },
            {
                filterDisplayName: "Tan",
                filterType: "metafield",
                filterNamespace: "custom",
                filterHandle: "tan",
                filterKey: "colour",
            },
            {
                filterDisplayName: "Red",
                filterType: "metafield",
                filterNamespace: "custom",
                filterHandle: "red",
                filterKey: "colour",
            },
            {
                filterDisplayName: "Green",
                filterType: "metafield",
                filterNamespace: "custom",
                filterHandle: "green",
                filterKey: "colour",
            },
            {
                filterDisplayName: "Brown",
                filterType: "metafield",
                filterNamespace: "custom",
                filterHandle: "brown",
                filterKey: "colour",
            },
            {
                filterDisplayName: "Pink",
                filterType: "metafield",
                filterNamespace: "custom",
                filterHandle: "pink",
                filterKey: "colour",
            },
            {
                filterDisplayName: "Purple",
                filterType: "metafield",
                filterNamespace: "custom",
                filterHandle: "purple",
                filterKey: "colour",
            },
            {
                filterDisplayName: "Orange",
                filterType: "metafield",
                filterNamespace: "custom",
                filterHandle: "orange",
                filterKey: "colour",
            },
        ],
    },
]

export { legsFilters }
